module.exports = __webpack_public_path__ + "static/media/click3.5cc40ee0.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/click3.ogg
// module id = 479
// module chunks = 0